import type { FaireProductEntity } from "../../entity_types/product";

export const p_bvmgg7mbhu: FaireProductEntity = {
  token: "p_bvmgg7mbhu",
  type: "product",
  name: "Linen Journal with Gilt Edges",
  brandName: "Favorite Story",
  imageUrl:
    "https://cdn.faire.com/fastly/62a5808ff5836010ce856f07bb7fa197d88f7c4e7b754e4ec0e3d468620cf24b.jpeg",
  priceDollars: 11,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/2f32dad9c0d2f09c44b9e3dda9d8930419fd62eb3aecd9e13b9aa8ccd6849d6e.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
